export default __webpack_public_path__ + "static/media/date_picker_icon.1217e661.svg";